import React, { useState } from "react";
import { formatNumber } from "../../../functions/Functions";

export default function NumberFormatter({ children }) {
  const parentValue = children.props.value;
  const [prevParentValue, setPrevParentValue] = useState(parentValue);
  const [inputValue, setInputValue] = useState(() => parentValue != null ? formatNumber(parentValue) : "");

  let needsSync = !Object.is(parentValue, prevParentValue);

  if (!needsSync) {
    const numParent = typeof parentValue === "number" ? parentValue : Number(String(parentValue ?? "").replace(/,/g, ""));
    const numInput = Number(String(inputValue ?? "").replace(/,/g, ""));
    if (!isNaN(numParent) && !isNaN(numInput) && numParent !== numInput) {
      needsSync = true;
    }
  }

  if (needsSync) {
    setPrevParentValue(parentValue);
    setInputValue(parentValue != null ? formatNumber(parentValue) : "");
  }

  const handleChange = (e) => {
    const value = String(e.target.value ?? "").replace(/,/g, "");
    if (!/^[0-9]*\.?[0-9]*$/.test(value)) return;

    setInputValue(formatNumber(value));
    children.props.onChange({
      target: { name: e.target?.name, value },
    });
  };

  const formattedChild = React.cloneElement(children, {
    onChange: handleChange,
    value: inputValue,
  });

  return (
    <div className="position-relative">
      {formattedChild}
    </div>
  );
}
